const FEATURES = [
  {
    id: 1,
    icon: 'ri-shield-check-line',
    title: '安全绿色导航',
    desc: '向日葵视频严格筛选合作的水果视频在线平台，所有入口均经过安全检测，无毒无弹窗，保障用户浏览安全。我们只收录正规运营的香蕉视频、西瓜视频免费、蜜桃视频等平台。',
  },
  {
    id: 2,
    icon: 'ri-speed-up-line',
    title: '高清不缓冲',
    desc: '依托优质植物视频平台资源，本站收录的平台均支持高清在线观看，多线路智能切换确保不缓冲流畅体验，让每一帧画面都清晰锐利。',
  },
  {
    id: 3,
    icon: 'ri-refresh-line',
    title: '每日更新追踪',
    desc: '编辑团队每日追踪各大水果视频在线平台最新上线内容，第一时间整理专题合集，让你不再错过蜜桃视频、樱花视频等平台的优质新片。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
            为什么选择我们
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            向日葵视频致力于打造最值得信赖的水果植物视频平台导航
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {FEATURES.map((item) => (
            <div
              key={item.id}
              className="group p-6 md:p-8 rounded-xl bg-background-100 border border-background-200/70 hover:border-accent-200 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${item.icon} text-accent-600 group-hover:text-background-50 text-xl transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold font-heading text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}